import React, { FC } from 'react';
import { useNavigate } from 'react-router-dom';

import ProgressStep from '../../components/ProgressStep';
import ProgressBar from '../../components/ProgressBar';
import TooltipInfo from '../../components/Tooltip';
import Button from '../../components/Button';
import Carousel from '../../components/Carousel';

import imgCard1 from '../../assets/svg/calculator.svg';
import imgCard2 from '../../assets/svg/location.svg';
import imgCard3 from '../../assets/svg/block.svg';
import imgCard4 from '../../assets/svg/dollar_sign.svg';

import StepInterface from '../../interfaces/Step';
import StepClass from '../../entities/Step';

import Card from './Card';

import RegisterService from '../../services/RegisterService';

import {
  gtmAttributesTooltipEnvvias,
  gtmAttributesUpdateFreightEnvviasPage,
} from '../../utils/gtmVariables';
import useGTMEventsTracker from '../../hooks/useGTMEventsTracker';
import Container from '../../components/Container';
import Typography from '../../components/Typography';

const Step = new StepClass();
const Service = new RegisterService();

const Envvias: FC<any> = () => {
  const current: number = 5;
  const steps: Array<StepInterface> = Step.steps();
  const navigate = useNavigate();
  const gtmEventsTracker = useGTMEventsTracker();

  gtmEventsTracker(gtmAttributesUpdateFreightEnvviasPage);

  const handleLastStep = () => {
    Service.registrationCompleted({}).then(() => {
      navigate('/pas/home');
    });
  };

  const cards = [
    <Card
      key="freight"
      img={imgCard1}
      alt="Frete"
      title="Frete mais barato"
      body="Não cobramos comissão sobre o frete."
    />,
    <Card
      key="tracking"
      alt="Rastreio"
      img={imgCard2}
      title="Rastreio certeiro"
      body="O rastreamento dos pedidos é automatizado."
    />,
    <Card
      key="cost"
      alt="Custo"
      img={imgCard3}
      title="Sem custo adicional"
      body="A adesão é totalmente gratuita."
    />,
    <Card
      key="warranty"
      alt="Garantia"
      img={imgCard4}
      title="Garantia de ressarcimento"
      body="Pra roubos, extravios e avarias."
    />,
  ];

  return (
    <section>
      <div className="mb-12 max-[768px]:hidden">
        <ProgressStep steps={steps} current={current} />
      </div>
      <Container className="hidden max-[768px]:block mb-12">
        <ProgressBar
          total={steps.length}
          step={current}
          subtitle={steps.find((e) => e.step === current)?.title ?? ''}
        />
      </Container>
      <Container className="flex md:justify-center md:items-center mb-2 gap-3">
        <Typography as="h1" variant="title1">
          Logística Envvias
        </Typography>
        <TooltipInfo
          text={
            <>
              É a nossa solução logística, que ajuda na operação e gestão das entregas.{' '}
              <b>Conheça o Envvias</b>
            </>
          }
          onClick={() => gtmEventsTracker(gtmAttributesTooltipEnvvias)}
        />
      </Container>
      <Container className="flex flex-col md:items-center">
        <Typography as="p" className="md:text-center">
          Aqui, você usa a plataforma de frete da Via. <br />
          <Typography as="b" variant="subtitle2">
            Com o Envvias Postagem, você conta com diversos benefícios:
          </Typography>
        </Typography>
      </Container>
      <Container className="hidden md:flex w-full mt-[72px] mb-16 flex-row items-center justify-center gap-4">
        {cards}
      </Container>
      <Container className="block md:hidden mt-[72px] mb-16 [&_.slick-slide]:pr-4 pb-8">
        <Carousel
          items={cards}
          customSettings={{
            responsive: [
              {
                breakpoint: 9999,
                settings: 'unslick',
              },
              {
                breakpoint: 768,
                settings: {
                  slidesToShow: 1.5,
                  slidesToScroll: 1,
                  initialSlide: 0,
                },
              },
            ],
          }}
        />
      </Container>
      <Container className="flex justify-center mb-16 md:mb-32">
        <Button
          text="Finalizar"
          type="button"
          variant="primary"
          classNames="mx-auto lg:w-[30rem]"
          onClick={handleLastStep}
        />
      </Container>
    </section>
  );
};

export default Envvias;
